module.exports = __webpack_public_path__ + "naghmeh-old-logo-temp-resized.png?f933fb868acb301e2f562541db3c21c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naghmeh-old-logo-temp-resized.png
// module id = 87
// module chunks = 0